import React from "react";
import { Routes, Route } from "react-router-dom";
import CustomRoute from "./CustomRoute";

import Entrar from "~/pages/Entrar";
import OrdemServico from "~/pages/OrdemServico";
import Sistema from "~/pages/Sistema";

export default function RouteList() {
  return (
    <Routes>
      {/* <CustomRoute exact path="/">
        <Redirect to="/" />
      </CustomRoute> */}

      {/* Rotas globais */}
      <Route path="/" element={<CustomRoute element={Entrar} />} />

      {/* Rotas Plataforma */}
      <Route path="/plataforma" element={<CustomRoute element={Sistema} privado />} />

      {/* Rotas Plataforma */}
      <Route
        path="/cliente/ordemservico/:os"
        element={<CustomRoute element={OrdemServico} privado={false} />}
      />
    </Routes>
  );
}
